import React from "react";

import { MemberProfileActivityEntry } from "@/component-library";
import { PatientInactivationTypeEnum } from "@/core/constants/patient";

export const MemberActivatedActivity = (props) => {
  const { keyContent, localCreatedTime } = props;
  const { provider_name } = keyContent;

  return (
    <MemberProfileActivityEntry
      headerClassName="apti-MemberProfileActivityEntry__Header__Dark"
      iconAlt="PatientActivatedIcon"
      iconSrc="activate_timeline.svg"
      localDateTime={localCreatedTime}
      subTitle={`Activated by ${provider_name}`}
      title="Patient Activated"
    />
  );
};

export const MemberInactivatedActivity = (props) => {
  const { keyContent, localCreatedTime } = props;
  const { inactivation_type, provider_name, reason_for_inactivation } = keyContent;

  const getTitle = () => {
    if (inactivation_type === PatientInactivationTypeEnum.accessRevoked) {
      return "Access Revoked";
    }

    return "Patient Inactivated";
  };

  const getSubTitle = () => {
    if (inactivation_type === PatientInactivationTypeEnum.accessRevoked) {
      return "Access Revoked by";
    }

    return "Inactivated by";
  };

  return (
    <MemberProfileActivityEntry
      headerClassName="apti-MemberProfileActivityEntry__Header__Dark"
      iconAlt="PatientInactivatedIcon"
      iconSrc="inactivated_timeline.svg"
      localDateTime={localCreatedTime}
      subTitle={`${getSubTitle()} ${provider_name}`}
      title={getTitle()}
    >
      <div className="fs-14">{`Reason: ${reason_for_inactivation}`}</div>
    </MemberProfileActivityEntry>
  );
};
